import config from "react-global-configuration";

const isDevelopmentBuild = process.env.NODE_ENV === "development";

const developmentDefaults = {
  url: "http://localhost:3007",
  auth: "http://sigtrip.test",
  api: "http://sigtrip.test/api",
  cdn: "http://sigtripcdn.test",
  api_sigtrip: "http://sigtrip.test/api",
  cdn_sigtrip: "http://sigtripcdn.test",
  api_sigmec: "http://sigmec.test/api",
  cdn_sigmec: "http://sigmeccdn.test",
  api_sigtrein: "http://sigtrein.test/api",
  cdn_sigtrein: "http://sigtreincdn.test",
  api_correios: "https://viacep.com.br/ws",
  refresh_time: 20,
};

const getEnvValue = (name, fallback = "") => {
  const value = process.env[name];

  if (typeof value !== "undefined" && value !== "") {
    return value;
  }

  return fallback;
};

const getBooleanEnvValue = (name, fallback = false) => {
  const value = process.env[name];

  if (typeof value === "undefined" || value === "") {
    return fallback;
  }

  return ["1", "true", "yes", "on"].includes(String(value).toLowerCase());
};

const getNumberEnvValue = (name, fallback) => {
  const value = process.env[name];

  if (typeof value === "undefined" || value === "") {
    return fallback;
  }

  const parsedValue = Number(value);

  return Number.isNaN(parsedValue) ? fallback : parsedValue;
};

const apiUrl = getEnvValue("REACT_APP_API", isDevelopmentBuild ? developmentDefaults.api : "");
const authUrl = getEnvValue(
  "REACT_APP_AUTH",
  apiUrl ? apiUrl.replace(/\/api$/, "") : (isDevelopmentBuild ? developmentDefaults.auth : "")
);

const globals = {
  url: getEnvValue("REACT_APP_URL", isDevelopmentBuild ? developmentDefaults.url : ""),
  auth: authUrl,
  api: apiUrl,
  cdn: getEnvValue("REACT_APP_CDN", isDevelopmentBuild ? developmentDefaults.cdn : ""),
  api_sigtrip: getEnvValue("REACT_APP_API_SIGTRIP", isDevelopmentBuild ? developmentDefaults.api_sigtrip : ""),
  cdn_sigtrip: getEnvValue("REACT_APP_CDN_SIGTRIP", isDevelopmentBuild ? developmentDefaults.cdn_sigtrip : ""),
  api_sigmec: getEnvValue("REACT_APP_API_SIGMEC", isDevelopmentBuild ? developmentDefaults.api_sigmec : ""),
  cdn_sigmec: getEnvValue("REACT_APP_CDN_SIGMEC", isDevelopmentBuild ? developmentDefaults.cdn_sigmec : ""),
  api_sigtrein: getEnvValue("REACT_APP_API_SIGTREIN", isDevelopmentBuild ? developmentDefaults.api_sigtrein : ""),
  cdn_sigtrein: getEnvValue("REACT_APP_CDN_SIGTREIN", isDevelopmentBuild ? developmentDefaults.cdn_sigtrein : ""),
  api_correios: getEnvValue("REACT_APP_API_CORREIOS", isDevelopmentBuild ? developmentDefaults.api_correios : ""),
  refresh_time: getNumberEnvValue("REACT_APP_REFRESH_TIME", developmentDefaults.refresh_time),
  development: getBooleanEnvValue("REACT_APP_DEVELOPMENT", isDevelopmentBuild),
  client_id: getEnvValue("REACT_APP_CLIENT_ID", ""),
  client_secret: getEnvValue("REACT_APP_CLIENT_SECRET", ""),
};

if (process.env.NODE_ENV === "production") {
  ["url", "api", "cdn"].forEach((key) => {
    if (!globals[key]) {
      console.warn(`SIGACL Browser: missing configuration for "${key}".`);
    }
  });
}

config.set({
  ...globals,
});

class Globals {}

export default Globals;



// WEBPACK FOOTER //
// ./src/Components/Miscelania/Globals.js